import InfoContentMotionWrapper from "Components/MotionWrapper/InfoContentMotionWrapper";
import { renderFormattedText } from "Lib/text-utils";
import styles from "Styles/CompanySize.module.css";
import emoji from "Assets/emoji/microphone.svg";
import ballGreen from "Assets/vectors/ball-green.svg";
import ballRed from "Assets/vectors/ball-red.svg";

const MarketingChannelInfoContent = ({ heading }) => {
  return (
    <InfoContentMotionWrapper>
      <h3 className={styles.heading}>{renderFormattedText(heading)}</h3>
      <div className={styles.decorativeElements}>
        <img
          src={emoji}
          alt="microphone emoji"
          style={{
            width: "120px",
            height: "120px",
            translate: "0px 92px",
          }}
        />
        <img
          style={{ width: "19px", height: "19px", translate: "180px 50px" }}
          src={ballRed}
          alt="red ball"
        />
        <img
          style={{ width: "30px", height: "30px", translate: "30px 180px" }}
          src={ballGreen}
          alt="green ball"
        />

        <svg
          style={{ width: "130px", height: "130px", translate: "100px 240px" }}
          xmlns="http://www.w3.org/2000/svg"
          width="129"
          height="130"
          viewBox="0 0 129 130"
          fill="none"
        >
          <path
            d="M100.411 100.33L117.335 101.285L110.505 85.7578L126.763 80.8556L115.037 68.6235L128.663 58.4516L113.451 50.9959L122.796 36.7816L105.936 34.9926L109.882 18.451L93.4107 22.5535L91.4738 5.67841L77.3698 15.1737L69.7932 5.79837e-05L59.7603 13.7427L47.4487 2.10321L42.7033 18.4378L27.1449 11.7374L28.2523 28.6883L11.3234 27.7308L18.1534 43.2579L1.89548 48.1601L13.6218 60.3922L0.000260432 70.5668L15.2117 78.0225L5.86662 92.2368L22.7223 94.0231L18.7804 110.567L35.2522 106.465L37.1891 123.34L51.2887 113.842L58.8697 129.018L68.8981 115.273L81.2097 126.912L85.9596 110.581L101.518 117.281L100.411 100.33Z"
            fill="#FCCA23"
          />
        </svg>
      </div>
    </InfoContentMotionWrapper>
  );
};

export default MarketingChannelInfoContent;
